import {DateTime} from 'luxon';
import {
  AttributionSignal,
  AttributionSignalStatistic,
  RemoteAttributionSignalStatistic,
  ServerAttributionSignal,
} from './attributionSignals.types';
import _map from 'lodash/map';
import _sum from 'lodash/sum';
import _pick from 'lodash/pick';
import {attributionAnalyticsMetrics} from './attributionSignals.consts';

function toClientAttributionSignal(
  attributionSignal: ServerAttributionSignal,
  index: number,
): AttributionSignal {
  return {
    ...attributionSignal,
    usedInCampaigns: attributionSignal.usedInCampaigns || [],
    priority: attributionSignal.priority || index,
    conditions: _map(attributionSignal.conditions, (condition, index) => {
      return {
        ...condition,
        id: index,
      };
    }),
  };
}

function toClientAttributionSignalStatistic(
  attributionSignalStatistic: RemoteAttributionSignalStatistic,
): AttributionSignalStatistic {
  const totalCount = _sum(
    _map(
      attributionAnalyticsMetrics,
      (metric) => attributionSignalStatistic?.[metric as keyof RemoteAttributionSignalStatistic],
    ),
  );

  return {
    attributionId: attributionSignalStatistic.attributionId,
    date: DateTime.fromISO(attributionSignalStatistic.date).toUTC(),
    countPerEventType: _pick(attributionSignalStatistic, attributionAnalyticsMetrics) as Record<
      string,
      number
    >,
    totalCount,
  };
}

export {toClientAttributionSignal, toClientAttributionSignalStatistic};
